
import { ReactNode } from 'react'
import './DetailContent.css'

const DetailContent = ({ children }: { children: ReactNode }) => {
    return (
        <div className='drawer-detail__content'>{children}</div>
    )
}

export default DetailContent
